import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/login/page.jsx");
